import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { markDeliveryOrderDelivered } from '../../services/deliveryConfirmationService';

const { FiCheckCircle, FiLoader } = FiIcons;

const DeliveryConfirmationButton = ({ order, onConfirmed }) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const [error, setError] = useState('');

  // Seller-side delivery confirmation is disabled.
  // Delivery orders are now completed by the buyer from their order details.
  if (!order?.seller_delivery_confirmation_enabled) {
    return null;
  }

  if (!order || order.status !== 'ready' || order.delivery_method !== 'delivery') {
    return null;
  }

  const handleConfirm = async (event) => {
    event.stopPropagation();

    if (!window.confirm('Mark this delivery order as delivered?')) {
      return;
    }

    setIsConfirming(true);
    setError('');

    try {
      await markDeliveryOrderDelivered(order.id, {
        source: 'seller_order_details',
        qr_required: false,
        pickup_code_required: false
      });
      window.dispatchEvent(new Event('sohlocal:orders-changed'));
      await onConfirmed?.();
    } catch (requestError) {
      setError(requestError.message || 'Unable to confirm delivery.');
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <div className="w-full sm:w-auto">
      <button
        type="button"
        onClick={handleConfirm}
        disabled={isConfirming}
        className="flex items-center justify-center rounded-xl bg-emerald-600 px-5 py-3 text-[10px] font-black uppercase tracking-widest text-white disabled:opacity-50"
      >
        {isConfirming ? (
          <SafeIcon icon={FiLoader} className="mr-2 animate-spin" />
        ) : (
          <SafeIcon icon={FiCheckCircle} className="mr-2" />
        )}
        Mark as Delivered
      </button>

      {error && (
        <p className="mt-2 text-xs font-bold text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default DeliveryConfirmationButton;